import { webapi } from '@/api/webapi.ts';
import { createNegociation, createQuote, endNegociation } from '@/store/pretrade/api/negociations.ts';

export const pretradeApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    createNegociation: createNegociation(builder),
    createQuote: createQuote(builder),
    endNegociation: endNegociation(builder),
  }),
});
